module.exports = __webpack_public_path__ + "img/Girl_030027.7eec5730.png";